import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { closestCenter, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { restrictToVerticalAxis, restrictToWindowEdges, } from '@dnd-kit/modifiers';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy, } from '@dnd-kit/sortable';
import { useState } from 'react';
import { useDraggableList } from './DraggableListContext';
import { Overlay } from './Overlay';
const INITIAL_STATE = Object.freeze({
    elementId: null,
    state: false,
});
export const DragAndDropWrapper = ({ DragOverlayComponent, RowComponent, children, }) => {
    const [dragAction, setDragAction] = useState(INITIAL_STATE);
    const { setSortedIds, sortedIds } = useDraggableList();
    const handleDragEnd = ({ active, over, }) => {
        if (over === null) {
            return;
        }
        const oldIndex = sortedIds.indexOf(active.id);
        const newIndex = sortedIds.indexOf(over.id);
        const reorderedIds = arrayMove(sortedIds, oldIndex, newIndex);
        if ((over === null || over === void 0 ? void 0 : over.id) === 'droppable' || Number.isNaN(newIndex) || newIndex < 0) {
            return;
        }
        setDragAction(INITIAL_STATE);
        setSortedIds(reorderedIds);
    };
    const handleDragStart = ({ active }) => {
        setDragAction({
            elementId: `${active.id}`,
            state: true,
        });
    };
    const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor), useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates,
    }));
    return (_jsxs(DndContext, { collisionDetection: closestCenter, modifiers: [restrictToVerticalAxis, restrictToWindowEdges], onDragEnd: handleDragEnd, onDragStart: handleDragStart, sensors: sensors, children: [_jsx(SortableContext, { items: sortedIds, strategy: verticalListSortingStrategy, children: children }), _jsx(Overlay, { dragAction: dragAction, DragOverlayComponent: DragOverlayComponent || RowComponent })] }));
};
//# sourceMappingURL=DragAndDropWrapper.js.map